import React from "react";

import { Button, Card, CardContent } from "@material-ui/core";
import { Trash, X } from "phosphor-react";
import useStyles from "./DeleteModal.style";

export default function DeleteModal({
  name,
  type,
  handleCloseDeleteModal,
  handleDelete,
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent className={classes.CardContent}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className={classes.trashContainer}>
              <Trash size={100} className={classes.trashIcon} />
            </div>
            <div style={{ width: "75%" }}>
              <p className={classes.headText}>Delete Confirmation</p>
              <p className={classes.text}>
                Are you sure you want to delete{" "}
                <span className={classes.boldText}>"{type}"</span> name with :{" "}
                <span className={classes.boldText}>"{name}"</span> ?
              </p>
            </div>
          </div>
          <div className={classes.buttonDiv}>
            <Button
              className={classes.yesButton}
              type="submit"
              size="small"
              disableElevation
              onClick={(e) => {
                e.stopPropagation();
                handleDelete();
              }}
            >
              <Trash size={20} />
              Delete it
            </Button>
            <Button
              className={classes.noButton}
              type="submit"
              size="small"
              disableElevation
              onClick={(e) => {
                e.stopPropagation();
                handleCloseDeleteModal();
              }}
            >
              <X size={20} />
              Cancel Delete
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
